<template>
  <div class="inline-block w-2 overflow-hidden">
    <div class="bg-p-500 h-1.5 w-1.5 origin-top-left -rotate-45 transform" />
  </div>
</template>
